"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDateRangeState = void 0;
var _react = require("react");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var initialState = {
  range: [null, null]
};
var useDateRangeState = function useDateRangeState(fieldName, onChange) {
  var _useState = (0, _react.useState)(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = (0, _react.useState)(initialState),
    _useState4 = _slicedToArray(_useState3, 2),
    dateState = _useState4[0],
    setDateState = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    anchorEl = _useState6[0],
    setAnchorEl = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    hoverDay = _useState8[0],
    setHoverDay = _useState8[1];
  var handleOnChange = (0, _react.useCallback)(function (range) {
    if (onChange) {
      onChange(fieldName, range);
    }
  }, [onChange, fieldName]);
  var changeDate = (0, _react.useCallback)(function (value) {
    setDateState(function (currentState) {
      var range = currentState.range,
        currentInput = currentState.currentInput;
      var newRange;
      if (currentInput === 'from') {
        newRange = [value, range[1]];
      } else {
        newRange = [range[0], value];
      }
      var newState = _objectSpread(_objectSpread({}, currentState), {}, {
        range: newRange
      });
      return newState;
    });
  }, [setDateState]);
  var setCurrentInput = (0, _react.useCallback)(function (input) {
    setDateState(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        currentInput: input
      });
    });
  }, [setDateState]);
  var handleClick = (0, _react.useCallback)(function (e) {
    setAnchorEl(e.target);
  }, [setAnchorEl]);
  var handleFromInputClick = (0, _react.useCallback)(function (e) {
    setCurrentInput('from');
    handleClick(e);
  }, [handleClick, setCurrentInput]);
  var handleToInputClick = (0, _react.useCallback)(function (e) {
    setCurrentInput('to');
    handleClick(e);
  }, [handleClick, setCurrentInput]);
  var handleClose = (0, _react.useCallback)(function () {
    setAnchorEl(undefined);
    setState(dateState);
    handleOnChange(dateState.range);
  }, [setAnchorEl, dateState, handleOnChange]);
  var handleDiscardChanges = (0, _react.useCallback)(function () {
    setAnchorEl(undefined);
    setDateState(state);
  }, [setAnchorEl, setDateState, state]);
  var setRange = (0, _react.useCallback)(function (range) {
    var triggerChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setDateState(function (currentState) {
      var newState = _objectSpread(_objectSpread({}, currentState), {}, {
        range: range
      });
      setAnchorEl(undefined);
      setState(newState);
      if (triggerChange) {
        handleOnChange(range);
      }
      return newState;
    });
  }, [setDateState, handleOnChange, setAnchorEl]);
  var clearValue = (0, _react.useCallback)(function (type) {
    setRange(type === 'from' ? [null, dateState.range[1]] : [dateState.range[0], null]);
  }, [setRange, dateState.range]);
  var clearFromValue = (0, _react.useCallback)(function () {
    return clearValue('from');
  }, [clearValue]);
  var clearToValue = (0, _react.useCallback)(function () {
    return clearValue('to');
  }, [clearValue]);
  return {
    dateState: dateState,
    state: state,
    anchorEl: anchorEl,
    hoverDay: hoverDay,
    setRange: setRange,
    changeDate: changeDate,
    setHoverDay: setHoverDay,
    handleClick: handleClick,
    handleClose: handleClose,
    setAnchorEl: setAnchorEl,
    clearToValue: clearToValue,
    clearFromValue: clearFromValue,
    setCurrentInput: setCurrentInput,
    handleToInputClick: handleToInputClick,
    handleFromInputClick: handleFromInputClick,
    handleDiscardChanges: handleDiscardChanges
  };
};
exports.useDateRangeState = useDateRangeState;